const config = {
    foodMass: 20,
    fireFood: 20,
    limitSplit: 16,
    defaultPlayerMass: 10,
    virus: {
        fill: "#33ff33",
        stroke: "#19D119",
        strokeWidth: 20,
        defaultMass: {
            from: 100,
            to: 150
        },
        splitMass: 180,
        uniformDisposition: false,
    },
    saasBlob: {
        fill: "#FF69B4",
        stroke: "#FF1493",
        strokeWidth: 10,
        defaultMass: {
            from: 200,
            to: 300
        },
        uniformDisposition: true,
    },
    gameWidth: 5000,
    gameHeight: 5000,
    gameMass: 20000,
    maxFood: 500,
    maxVirus: 50,
    slowBase: 4.5,
    foodUniformDisposition: true,
    newPlayerInitialPosition: "farthest",
    massLossRate: 1,
    minMassLoss: 50,
    levelObjectives: [3, 5, 7], // Number of blobs to collect for levels 1, 2, and 3
};

export default config;
